import {inject} from 'vue'

export default function useDialog() {

    const $vfm = inject('$vfm')

    const showLoader = (title) => {
        $vfm.show({component: 'SlDialogLoader', bind: {title}})
    }

    const showLoaderLoading = () => {
        showLoader('Chargement...')
    }

    const showLoaderSending = (attach = false) => {
        showLoader('Envoi...', attach)
    }

    const showPopinError = (msg) => {
        $vfm.show({component: 'SlDialogError', bind: {msg}})
    }

    const showPopin = (title, msg, attach = false) => {
        $vfm.show({component: 'SlDialog', bind: {msg, title, attach}})
    }

    const hideLoader = () => {
        $vfm.hide('sl-dialog-loader')
    }

    return {
        showLoader,
        showLoaderLoading,
        showLoaderSending,
        showPopinError,
        showPopin,
        hideLoader
    }
}
